import type { AssetRopaReviewStatus } from 'config/api/ropaReviews/ropaReviews.types';

import type { AssetRopaDpiaFilterFields } from './assetRopaDpiaFilters';
import { DEFAULT_ASSET_ROPA_DPIA_FILTER_FIELDS } from './assetRopaDpiaFilters';
import type { AssetRopaOwnerFilterCompleteness, AssetRopaOwnerFilterGdprRelevance } from './assetRopaOwnerFilter.types';

export type AssetRopaBooleanFilterValue = '' | 'true' | 'false';

export type AssetRopaFilterPaginationOptions = {
  page?: number;
  pageSize?: number;
};

export type AssetRopaSharedFilterFields = {
  search: string;
  assetTypeId: '' | number;
  sensitivePersonalData: AssetRopaBooleanFilterValue;
  thirdCountryProcessing: AssetRopaBooleanFilterValue;
};

export type AssetRopaReviewFilters = AssetRopaSharedFilterFields &
  AssetRopaDpiaFilterFields & {
    reviewStatus: '' | AssetRopaReviewStatus;
    operationalOwnerMembershipId: '' | number;
    warningState: '' | 'with_warnings' | 'no_warnings';
  };

export const DEFAULT_ASSET_ROPA_REVIEW_FILTERS: AssetRopaReviewFilters = {
  search: '',
  reviewStatus: '',
  assetTypeId: '',
  operationalOwnerMembershipId: '',
  warningState: '',
  ...DEFAULT_ASSET_ROPA_DPIA_FILTER_FIELDS,
  sensitivePersonalData: '',
  thirdCountryProcessing: '',
};

export type OwnerWorkspaceFilters = AssetRopaSharedFilterFields &
  AssetRopaDpiaFilterFields & {
    completeness: '' | AssetRopaOwnerFilterCompleteness;
    gdprRelevance: AssetRopaOwnerFilterGdprRelevance;
  };

export const DEFAULT_OWNER_WORKSPACE_FILTERS: OwnerWorkspaceFilters = {
  search: '',
  assetTypeId: '',
  completeness: '',
  gdprRelevance: 'currently_indicated',
  ...DEFAULT_ASSET_ROPA_DPIA_FILTER_FIELDS,
  sensitivePersonalData: '',
  thirdCountryProcessing: '',
};
